import { render, staticRenderFns } from "./ReferencesAvbAnswers.vue?vue&type=template&id=b7f43232"
import script from "./ReferencesAvbAnswers.vue?vue&type=script&lang=js"
export * from "./ReferencesAvbAnswers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports